/**
 * Start Modification
 * Yellow Earth Australia — email popup config.
 * Edit values here to change copy, timing, targeting, or the offer.
 * No other file needs to change for day-to-day tweaks.
 */
window.YE_POPUP_CONFIG = {
  klaviyo: {
    companyId: "W5A7kV", // Klaviyo public API key (safe to expose client-side)
    listId: "VnCw8h" // "THM Optimonk $5 and Free Ship - Mystery Offer" — triggers the live welcome flow that emails the code
  },

  // Informational only — the code itself is never shown in the popup. It arrives
  // via the Klaviyo flow triggered by joining the list above.
  discount: {
    code: "WELCOMEHOME",
    label: "$5 off your first order"
  },

  // Transparent-background cutouts (background removed and re-hosted on
  // Shopify's CDN) so the products float directly on the card.
  productImages: [
    {
      url: "https://cdn.shopify.com/s/files/1/0022/2117/8953/files/ye-popup-hiking-low-boot-transparent.png",
      alt: "Hiking Low Boot"
    },
    {
      url: "https://cdn.shopify.com/s/files/1/0022/2117/8953/files/ye-popup-long-wool-rug-transparent.png",
      alt: "Long Wool Sheepskin Rug XXL - Ivory"
    },
    {
      url: "https://cdn.shopify.com/s/files/1/0022/2117/8953/files/ye-popup-car-seat-cover-transparent.png",
      alt: "Sheepskin Car Seat Cover"
    }
  ],

  triggers: {
    exitIntent: { enabled: true },
    timeDelay: { enabled: true, seconds: 30 },
    scrollDepth: { enabled: true, percent: 60 },
    onLoad: { enabled: false }
  },

  frequency: {
    maxImpressions: 2,
    minHoursBetweenImpressions: 1
  },

  targeting: {
    // Path prefixes where the popup should never show
    excludePaths: ["/cart", "/checkout", "/account", "/policies"],
    newVisitorsOnly: true,
    excludePastCustomers: true
  },

  copy: {
    heading: "CONGRATULATIONS!",
    subheading: "YOU'VE UNLOCKED A MYSTERY DISCOUNT",
    body: "Ready to see what you got? Enter your email below...",
    emailPlaceholder: "Email",
    submitButton: "REVEAL CODE",
    noThanksButton: "NO THANKS, I'LL PAY FULL PRICE",
    successHeading: "You're In!",
    successSubheading: "Your code is on the way...",
    successMessage: "Thanks for joining our wooly family, your discount code is on the way.",
    successMessage2: "Please check your email for a message from us! Make sure to check your Junk/Spam/Promo folder as we don't always hit your inbox...",
    errorMessage: "Something went wrong. Please try again.",
    invalidEmailMessage: "Please enter a valid email address."
  }
};
/* End Modification */